module.exports = __webpack_public_path__ + "img/中山韩妃.41f7b05.png";